import React from 'react';
import { twoDigit } from '../format';

/**
 * One viewport-height chapter of the Portfolio Story.
 *
 * Renders the shared header row every chapter opens with — the `NN / NN`
 * counter and a tag — plus an optional right-aligned action. The counter and
 * total are passed in rather than hard-coded because chapter 08 disappears for
 * users with no insights and everything after it renumbers.
 *
 * @param {Object} props
 * @param {string} props.id - Anchor id (`story-chapter-3`)
 * @param {number} props.index - 1-based position in the rendered chapter list
 * @param {number} props.total - Number of chapters actually rendered
 * @param {string} props.tag - Tag label (`ALLOCATION`, `TREND`, …)
 * @param {'accent'|'neutral'|'outline-light'} [props.tagVariant='neutral']
 * @param {React.ReactNode} [props.action] - Right-aligned header content
 * @param {string} [props.className] - Extra class on the section
 * @param {string} props.label - Accessible name for the section
 * @param {React.ReactNode} props.children
 */
const Chapter = React.forwardRef(function Chapter(
  { id, index, total, tag, tagVariant = 'neutral', action, className = '', label, children },
  ref
) {
  return (
    <section
      id={id}
      ref={ref}
      aria-label={label}
      data-chapter={index}
      className={`story-chapter ${className}`.trim()}
    >
      <div className="story-chapter-head">
        <div className="story-chapter-head-left">
          <span className="story-counter">
            {twoDigit(index)} / {twoDigit(total)}
          </span>
          <span className={`story-tag story-tag-${tagVariant}`}>{tag}</span>
        </div>
        {action}
      </div>
      {children}
    </section>
  );
});

export default Chapter;
